/* Ouverture automatique du tiroir panier quand le nombre d'articles augmente
   (ajouts faits par des scripts tiers, retour arrière du navigateur, etc.).
   Le correctif d'affichage Dealeasy (août 2026) a été retiré avec l'application. */
(function(){
  var K="nutricim:lastCount",last=null,busy=false;
  if(location.pathname.indexOf("/cart")===0)return;
  function get(){return fetch("/cart.js",{credentials:"same-origin"}).then(function(r){return r.json()})}
  function show(){
    var d=document.getElementById("CartDrawer");
    if(!d||busy||d.classList.contains("is-open"))return;
    busy=true;
    fetch("/cart?sections=cart-drawer",{credentials:"same-origin"}).then(function(r){return r.json()}).then(function(j){
      var h=j&&j["cart-drawer"];
      if(h){var p=new DOMParser().parseFromString(h,"text/html"),f=p.querySelector("[data-cart-body]"),c=d.querySelector("[data-cart-body]");if(f&&c)c.innerHTML=f.innerHTML}
      return get();
    }).then(function(c){
      document.querySelectorAll("[data-cart-count]").forEach(function(e){e.textContent=c.item_count});
      d.classList.add("is-open");
    }).catch(function(){}).then(function(){busy=false});
  }
  function tick(){get().then(function(c){var n=c.item_count;if(last!==null&&n>last)show();last=n}).catch(function(){})}
  function boot(){
    var prev=null;try{prev=sessionStorage.getItem(K)}catch(e){}
    get().then(function(c){last=c.item_count;try{sessionStorage.setItem(K,c.item_count)}catch(e){}if(prev!==null&&c.item_count>+prev)show()});
    setInterval(tick,1500);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
})();
